import React from 'react';
import _ from 'lodash';
import { BDataGrid } from '../../common/dataGrid/BDataGrid';
import BrowserUtils from '../../../utils/BrowserUtils';
import ViewArchiveComponent from './ViewArchiveComponent';
import ManagePaymentBL from '../ManagePaymentBL';
import { CustomComponentArchive } from './CustomComponentArchive';
import { Nav, NavItem } from 'react-bootstrap';
import NumberUtils from '../../../utils/NumberUtils';
import StringConstant from '../../../constants/StringConstants';
import LoaderComponent from '../../common/LoaderComponent';
import PrintHelper from 'print-helper-lib';
import envConfig from '../../../../static/config';

const columnMeta = [
  {
    columnName: 'fromAccountId',
    order: 1,
    locked: false,
    visible: false,
    displayName: '',
    sortable: false,
  },
  {
    columnName: 'id',
    order: 2,
    locked: false,
    visible: true,
    displayName: 'ID',
    sortable: true,
  },
  {
    columnName: 'fromAccountName',
    order: 3,
    locked: false,
    visible: true,
    displayName: 'From',
    sortable: true,
    sortDirectionCycle: ['desc', 'asc'],
    cssClassName: 'column-from',
  },
  {
    columnName: 'toAccountName',
    order: 4,
    locked: false,
    visible: true,
    displayName: 'To',
    sortable: true,
    customComponent: CustomComponentArchive,
    cssClassName: 'column-to',
  },
  {
    columnName: 'type',
    order: 5,
    locked: false,
    visible: true,
    sortable: true,
    displayName: 'Type ',
    cssClassName: 'column-type',
  },
  {
    columnName: 'amount',
    order: 6,
    locked: false,
    visible: true,
    displayName: 'Amount',
    sortable: true,
    cssClassName: 'column-amount',
    customComponent: CustomComponentArchive,
  },
  {
    columnName: 'option',
    order: 7,
    locked: false,
    visible: true,
    displayName: 'Options',
    sortable: false,
    customComponent: CustomComponentArchive,
    cssClassName: 'column-reference',
  },
];

class ArchivePaymentList extends React.Component {
  constructor(props) {
    super(props);
    this.onResize = this.onResize.bind(this);
    this.onSort = this.onSort.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.onCustomClick = this.onCustomClick.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.renderMobileData = this.renderMobileData.bind(this);
    this.customLoadingComponent = this.customLoadingComponent.bind(this);
    this.state = {
      _mergeList: this.props.cancelledList,
      navActiveKey: 1,
    };
  }

  componentWillMount() {
    window.addEventListener('resize', this.onResize);
    if (BrowserUtils.isTabletView()) {
      this.state = { isTablet: true };
    } else {
      this.state = { isTablet: false };
    }
  }

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {
    this.setState({
      _mergeList: nextProps.cancelledList,
    });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  onResize() {
    if (BrowserUtils.isTabletView() && !this.state.isTablet) {
      this.setState({ isTablet: true });
    } else if (!BrowserUtils.isTabletView() && this.state.isTablet) {
      this.setState({ isTablet: false });
    }
  }

  onRowClick(row) {
    this.setState({ viewArchive: true, viewData: row.props.data });
  }

  onCustomClick(row, type, e) {
    if (e) e.preventDefault();
    this.setState({ viewArchive: true, viewData: row });
  }

  onViewClose() {
    this.setState({ viewArchive: false, viewData: null });
  }

  onSort(sort, sortAscending) {
    const sortedData = ManagePaymentBL.sortPayment(
      this.state._mergeList,
      sort,
      sortAscending
    );
    this.setState({ _mergeList: sortedData });
  }

  customLoadingComponent() {
    if (!this.props.hasError) {
      return <LoaderComponent type="small" />;
    } else {
      return (
        <div className="text-center">
          <div className="errormessage">{this.props.errorObject.message}</div>
          <button
            onClick={this.props.clickToReload}
            className="c-btn c-btn--default"
          >
            Retry
          </button>
        </div>
      );
    }
  }

  handleSelect(selectedKey) {
    const filteredList = ManagePaymentBL.filterPaymentList(
      this.props.cancelledList,
      selectedKey
    );
    this.setState({ navActiveKey: selectedKey, _mergeList: filteredList });
  }

  showNavBar() {
    return (
      <Nav
        bsStyle="pills"
        activeKey={this.state.navActiveKey}
        onSelect={this.handleSelect}
      >
        <NavItem eventKey={1} href="/home">
          All
        </NavItem>
        <NavItem eventKey={2} title="Item">
          Direct Debits
        </NavItem>
        <NavItem eventKey={3}>Standing Orders</NavItem>
        <NavItem eventKey={4}>Other scheduled payments</NavItem>
      </Nav>
    );
  }

  showDesktopView() {
    //  will come in future
    //	{ this.props.isCreditCardUser ? this.showNavBar() : null }
    return (
      <div className="manage-payments-table-container manage-payments-table-container-medium">
        <BDataGrid
          results={this.state._mergeList}
          columns={[
            'fromAccountName',
            'toAccountName',
            'type',
            'amount',
            'option',
          ]}
          columnMetadata={columnMeta}
          useCustomPagerComponent="true"
          initialSortAscending
          isFooterEnabled
          onRowClick={this.onRowClick}
          onSort={this.onSort}
          rowClick={this.rowClick}
          initialSort="fromAccountName"
          enableInfiniteScroll
          content={this.props.content}
          rowExpander
          customClick={this.onCustomClick}
          externalIsLoading={this.props.isLoading}
          externalLoadingComponent={this.customLoadingComponent}
          tableClassName="manage-payments-table manage-payments-table-medium manage-payments-table--ellipsis"
          showPager={false}
          noDataMessage={StringConstant.noArchiveText}
        />
      </div>
    );
  }

  closeModal() {
    this.setState({ viewArchive: !this.state.viewArchive });
  }

  showArchiveView() {
    return (
      <ViewArchiveComponent
        closeModal={this.closeModal}
        archieveData={this.state.viewData}
      />
    );
  }

  renderMobileData() {
    if (this.props.isLoading) {
      return (
        <div className="accountGridNoTransaction text-center">
          {this.customLoadingComponent()}
        </div>
      );
    } else if (this.props.cancelledList.length === 0) {
      return (
        <div className="accountGridNoTransaction text-center">
          <p>{StringConstant.noArchiveText}</p>
        </div>
      );
    } else {
      const tableList = _.map(this.state._mergeList, (paymentData) => {
        let amount = '-';
        if (paymentData.amount === undefined || paymentData.amount === null) {
          amount = '-';
        } else {
          amount = `£ ${NumberUtils.decimalFormat(
            paymentData.amount,
            3,
            false
          )}`;
        }
        return (
          <table
            className="manage-payments-table manage-payments-table-xsmall"
            cellPadding="0"
            cellSpacing="0"
            onClick={(e) => this.onCustomClick(paymentData, e)}
          >
            <tbody className="manage-payments-table__is-clickable">
              <tr>
                <th width="100">From</th>
                <td>{paymentData.fromAccountName}</td>
              </tr>
              <tr>
                <th>To</th>
                <td>
                  {paymentData.toAccountName}, {paymentData.reference}
                </td>
              </tr>
              <tr>
                <th>Type</th>
                <td>{paymentData.type}</td>
              </tr>
              <tr>
                <th>Amount</th>
                <td>{amount}</td>
              </tr>
              <tr>
                <th>Options</th>
                <td>
                  <a className="">View</a>
                </td>
              </tr>
            </tbody>
          </table>
        );
      });
      return tableList;
    }
  }

  showMobileView() {
    /* if (this.props.isLoading) {
			this.customLoadingComponent();
		} else {*/
    return (
      <div className="manage-payments-table-container-xsmall">
        {this.renderMobileData()}
      </div>
    );
    // }
  }

  render() {
    return (
      <PrintHelper
        className="web-ui-components"
        brandId={envConfig.brandId}
        showPrintTopIcon
        showPrintBottomIcon={false}
      >
        <div>
          {this.state.isTablet ? this.showMobileView() : this.showDesktopView()}
          <p className="u-text-center">{this.props.content.cancelledFooter}</p>
          {this.state.viewArchive ? this.showArchiveView() : null}
        </div>
      </PrintHelper>
    );
  }
}

ArchivePaymentList.defaultProps = {
  icon: ['glyphicon glyphicon-remove', 'glyphicon glyphicon-remove'],
  titleName: ['More than one word Tab', 'Tab2'],
  tabContent: ['Default_Props Tab1 Content', 'Tab2 Content'],
  IconFlag: false,
  isLoading: 'false',
  isCreditCardUser: true,
};

export default ArchivePaymentList;
